var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 14,
    viewBox: "0 0 3 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49 0c.448 0 .812.141 1.091.424.28.289.419.648.419 1.078 0 .437-.14.796-.419 1.079-.279.288-.643.433-1.09.433-.442 0-.803-.141-1.082-.424C.136 2.307 0 1.945 0 1.502 0 1.066.136.707.41.424.687.141 1.048 0 1.49 0zM1.49 5.493c.448 0 .812.141 1.091.424.28.289.419.648.419 1.078 0 .437-.14.796-.419 1.079-.279.289-.643.433-1.09.433-.442 0-.803-.141-1.082-.424C.136 7.8 0 7.438 0 6.995 0 6.56.136 6.2.41 5.917c.278-.283.639-.424 1.08-.424zM1.49 10.986c.448 0 .812.141 1.091.424.28.289.419.648.419 1.079 0 .436-.14.795-.419 1.078-.279.289-.643.433-1.09.433-.442 0-.803-.141-1.082-.424C.136 13.293 0 12.931 0 12.488c0-.436.136-.795.41-1.078.278-.283.639-.424 1.08-.424z",
    fill: "#fff"
  })));
}

SvgDots.displayName = 'Dots';
export default SvgDots;